import { v4 as uuid } from "uuid";
import { z } from "zod";
export const contactInfoLineItemSchema = z.object({
    address: z.string(),
    city: z.string(),
    country: z.string(),
    geoLocationLat: z.number().optional(),
    geoLocationLong: z.number().optional(),
    id: z.string(),
    phoneNumber: z.string().optional(),
    postCode: z.string(),
    state: z.string()
});
export const createDefaultContactInfo = () => contactInfoLineItemSchema.parse({
    address: "",
    city: "",
    country: "AU",
    id: uuid(),
    postCode: "",
    state: ""
});
